import { useEffect, useRef } from 'react';

const InactivityReloader = () => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      console.log('No user activity for 5 minutes. Reloading...');
      window.location.reload();
    }, 5 * 60 * 1000); // 5 minutes
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;

    resetTimer(); // Start timer on mount

    const handleActivity = () => resetTimer();

    const events = [
      'mousemove',
      'keydown',
      'scroll',
      'click',
      'touchstart',
      'touchmove',
      'touchend',
      'touchcancel',
      'wheel',
      'resize',
    ];

    events.forEach(event =>
      window.addEventListener(event, handleActivity)
    );

    return () => {
      events.forEach(event =>
        window.removeEventListener(event, handleActivity)
      );
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return null;
};

export default InactivityReloader;
